<template>
    <b-navbar-brand
        class="mr-5"
        @click="doRedirect"
    >
        <riskhub-logo></riskhub-logo>
    </b-navbar-brand>
</template>

<script>
import RiskhubLogo from '@/components/Logo/RiskhubLogo';
import User from '@/services/User/User';

export default {
  name: 'NavBrand',
  components: { RiskhubLogo },
  methods: {
    doRedirect() {
      this.$router.push({ name: User.getDefaultRouteForPermission(this.$store.getters.permissions) });
    }
  }
};
</script>
